import { SectionIds } from "site/sections";

export enum Lang {
  'ru' = 'ru',
}

type TranslateVariants = {
  one: string;
  two: string;
  five: string;
}

type Translate = { [key in Lang]: {
  sections: Partial<{ [key in SectionIds]: {
    title: string;
    description?: string;
    demos?: { [k: number]: string },
    labels?: { [k: string]: string },
  } }>,
} };

const trsSections: Translate = {
} as any;

export const trs = Object.assign({
  [Lang.ru]: {
    days: {
      one: "день",
      two: "дня",
      five: "дней",
    },
    daysLeft: {
      one: "остался %% день",
      two: "осталось %% дня",
      five: "осталось %% дней",
    },
    seconds: {
      one: "секунда",
      two: "секунды",
      five: "секунд",
    },
    hours: {
      one: "час",
      two: "часа",
      five: "часов",
    },
    minutes: {
      one: "минута",
      two: "минуты",
      five: "минут",
    },
    bonuses: {
      one: "бонус",
      two: "бонуса",
      five: "бонусов",
    },
  }
}, trsSections);